import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from '../../app-routing.module';
import { SharedModule } from '@shared/shared.module';
import * as souscription from './';
import { DocumentMedicaleModule } from './document-medicale/document-medicale.module';

@NgModule({
    declarations: [
        ...souscription.components,
        ...souscription.directives,
        ...souscription.pipes,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        SharedModule,
        ReactiveFormsModule,
        DocumentMedicaleModule,
    ],
    exports: [
        CommonModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        ...souscription.components,
        ...souscription.directives,
        ...souscription.pipes,
    ],
})
export class SouscriptionModule {}
